import PropTypes from 'prop-types'
import { useMemo, useRef } from 'react'
import { SnackbarProvider } from 'notistack'
import { Icon } from '@iconify/react'
import infoFill from '@iconify/icons-eva/info-fill'
import alertTriangleFill from '@iconify/icons-eva/alert-triangle-fill'
import IconButton from '@mui/material/IconButton'
import Box from '@mui/material/Box'
import CloseIcon from '@mui/icons-material/Close'
import { alpha, useTheme } from '@mui/material/styles'

export default function NotistackProvider({ children }) {
  const theme = useTheme()
  const notistackRef = useRef(null)

  const iconVariant = useMemo(
    () => ({
      info: (
        <Box sx={{ mr: 1, display: 'flex', alignItems: 'center' }}>
          <Icon icon={infoFill} width={24} height={24} />
        </Box>
      ),
      success: (
        <Box sx={{ mr: 1, display: 'flex', alignItems: 'center' }}>
          <Icon icon={infoFill} width={24} height={24} />
        </Box>
      ),
      warning: (
        <Box sx={{ mr: 1, display: 'flex', alignItems: 'center' }}>
          <Icon icon={alertTriangleFill} width={24} height={24} />
        </Box>
      ),
      error: (
        <Box sx={{ mr: 1, display: 'flex', alignItems: 'center' }}>
          <Icon icon={alertTriangleFill} width={24} height={24} />
        </Box>
      ),
    }),
    []
  )

  return (
    <SnackbarProvider
      ref={notistackRef}
      maxSnack={3}
      preventDuplicate
      dense
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      // Native app UI (WebView) often has a top overlay; safe-area padding prevents snackbars
      // from colliding with status bars / headers.
      style={{ top: 'calc(8px + env(safe-area-inset-top, 0px))' }}
      iconVariant={iconVariant}
      action={(snackbarKey) => (
        <IconButton
          size="small"
          onClick={() => notistackRef.current?.closeSnackbar(snackbarKey)}
          sx={{ color: alpha(theme.palette.common.white, 0.9) }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      )}
    >
      {children}
    </SnackbarProvider>
  )
}

NotistackProvider.propTypes = {
  children: PropTypes.node,
}